import { render, staticRenderFns } from "./EventsNew.vue?vue&type=template&id=55d7fa65&"
import script from "./EventsNew.vue?vue&type=script&lang=js&"
export * from "./EventsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports